import React from "react"
import {
  Container,
} from "reactstrap"

const MortalityType = () => {
  //meta title
  document.title="NattoLabs - Painel Adminitrativo";
  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <h4>Tipo de Mortalidade - Produção de Ovos</h4>
      </Container>
    </div>
  </React.Fragment>
  );
}

export default MortalityType;
